<!-- Copyright (c) ArubaCC - All Rights Reserved. -->

@if (status !== null) {
  <aup-status-chip
    [status]="status"
    [statusesMap]="sentInvoicesPaymentStatusesMap"
  ></aup-status-chip>
}
